/** an item in a select list, and the type of the `selected` item */
export class SelectItem {
  constructor(
    public id: number | string,
    public text: string,
    public selected?: boolean,
  ) {}
}
